export function getFileExtension(filename) {
  return filename.split(".").pop().toLowerCase();
}

export function isAllowedFileExtension(filename, allowedExtensions) {
  return allowedExtensions.includes(getFileExtension(filename));
}
